import React, { useState } from "react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { toast } from "sonner";
import { ShieldCheck, ExternalLink } from "lucide-react";
import { researchApi, errMsg } from "@/lib/research";
import { VerificationBadge } from "./AuthorityCard";

export function ExternalLinks({ items, className = "" }) {
  return (
    <div className={`flex flex-wrap gap-1.5 ${className}`} data-testid="external-providers">
      {items.map((p) => (
        <a key={p.provider} href={p.url} target="_blank" rel="noreferrer" className="inline-flex items-center gap-1 rounded-full border border-line px-2 py-0.5 text-[11px] text-ink-2 hover:border-copper/40" data-testid={`provider-${p.provider.replace(/\s/g, "-")}`}>
          <ExternalLink className="h-3 w-3" /> {p.provider} <span className="text-[9px] uppercase text-ink-muted">{p.status === "LINK_ONLY" ? "link-out" : "not connected"}</span>
        </a>
      ))}
    </div>
  );
}

export function CitationVerifier({ compact = false }) {
  const [cite, setCite] = useState("");
  const [res, setRes] = useState(null);
  const [busy, setBusy] = useState(false);
  const run = async () => {
    if (!cite.trim()) return;
    setBusy(true);
    try { setRes(await researchApi.verifyCitation({ citation: cite })); } catch (e) { toast.error(errMsg(e)); } finally { setBusy(false); }
  };
  return (
    <div className="rounded-xl border border-line bg-card p-3" data-testid="citation-verifier">
      <div className="mb-2 flex items-center gap-1 text-xs font-semibold text-ink"><ShieldCheck className="h-3.5 w-3.5 text-copper" /> Verify a citation</div>
      <div className="flex gap-1.5">
        <Input value={cite} onChange={(e) => setCite(e.target.value)} onKeyDown={(e) => e.key === "Enter" && run()} placeholder="(2021) 8 SCC 271 or case title" className="h-8 text-xs" data-testid="verify-input" />
        <Button size="sm" disabled={busy} onClick={run} data-testid="verify-btn">{busy ? "…" : "Check"}</Button>
      </div>
      {res && (
        <div className="mt-2 space-y-1.5 text-xs" data-testid="verify-result">
          <div className="flex items-center gap-2"><VerificationBadge status={res.status} />{res.authority && <span className="text-ink-2">{res.authority.title}</span>}{res.document && <span className="text-ink-2">in {res.document.name}</span>}</div>
          {!compact && <p className="text-[11px] text-ink-muted">{res.note}</p>}
          <ExternalLinks items={res.external} />
        </div>
      )}
    </div>
  );
}
